import React, { useEffect, useState } from "react";
import {
	Row, Col, Card, CardBody, Input, Label, Button, Form, Alert, Badge, Table
} from "reactstrap";
import Loader from "common/loader";
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { post, get, put } from "../../helpers/api_helper";
import { DRIVERS_SEARCH, CLEAR_COLLECTOR_WALLET, UPLOAD_FILE, TRANSFER_DRIVER_WALLET, PARTNERS_BRANCH_SEARCH, PARTNERS_SEARCH } from "helpers/api_endpoints";
import Select from "react-select";
import { Trans } from "react-i18next";

const TransferWallet = ({ type=1, id = "" }) => {
	const [change, setChange] = useState(0);
	const [loading, setLoading] = useState(false);
	const [errorMsg, setErrorMsg] = useState('');
	const [drivers, setDrivers] = useState([]);
	const [partners, setPartners] = useState([]);
	const [partnerBranches, setPartnerBranches] = useState([]);
	const [driverId, setDriverId] = useState(null);
	const [driver, setDriver] = useState(null);
	const [partnerId, setPartnerId] = useState(null);
	const [partnerBranchId, setPartnerBranchId] = useState(null);
	const [walletBalance, setWalletBalance] = useState(null);
	const [search, setSearch] = useState(false);
	const [message, setMessage] = useState(null);
	const [trDate, setTrDate] = useState(new Date().toISOString().split('T')[0]);
	const [trDateFrom, setTrDateFrom] = useState(new Date().toISOString().split('T')[0]);
	const [trDateTo, setTrDateTo] = useState(new Date().toISOString().split('T')[0]);
	const [status, setStatus] = useState('');
    let sum=0;
	const per = JSON.parse(localStorage.getItem('authUser')).user.Roles.map(el => el.RolePermissions.map(pr => pr.Screen.id==77 && pr.PermissionId==3)).flat().filter(el => el)[0];

	useEffect(() => {
        setLoading(true);
		post(DRIVERS_SEARCH)
			.then(response => {
				const data = response.data;
				setDrivers(data.map(el => 
					({value:el.id,label:el.name + (el.expressDeliveryStatus?' (Express)':'') + (el.verifiedAll?' (Verified)':'') + ' ' 
						+ el.currentStatus, data:el})));
                setLoading(false);
			})
			.catch(() => setErrorMsg("Failed to load "));
		}, []);

	useEffect(() => {
        setLoading(true);
		post(DRIVERS_SEARCH, {id: driverId, withWallet: 1, trDateFrom: trDateFrom??1, trDateTo: trDateTo??1})
			.then(response => {
				const data = response.data;
				setDriver(data[0]);
                setLoading(false);
			})
			.catch(() => setErrorMsg("Failed to load "));
		}, [search]);


	useEffect(() => {
		post(PARTNERS_SEARCH)
			.then(response => {
				const data = response.data;
				setPartners(data.map(el => 
					({value:el.id,label:el.name , data:el})));
			})
			.catch(() => setErrorMsg("Failed to load "));
		}, []);

	// useEffect(() => {
    //     console.log('a',partnerBranchId, drivers.find(el => el.value == driverId?.toString())?.data.user.wallet?.find(w => {console.log('rr',w.partnerBranchId, partnerBranchId); return w.partnerBranchId == partnerBranchId}))
	// 	}, [driverId]);

	const handleTransferWallet = () => {
		if(!walletBalance || walletBalance <1 )
		{
			setMessage('New balance is not correct')
			setTimeout(() => {setMessage('')}, 1700);
            return;
		}
		if(confirm('Are you sure you want to transfer?'))
		{
			post(TRANSFER_DRIVER_WALLET, {driverId, amount: walletBalance, partnerId, partnerBranchId})
			.then(response => {
				setMessage(response.message);
				setTimeout(() => {setMessage('')}, 1700);
			})
			.catch(() => setErrorMsg("Failed to load "));
		}
	}

    const handlePartnerId = (partnerId) =>
    {
        setPartnerId(partnerId);
        setPartnerBranches(partners.find(el => el.value == partnerId)?.data?.partnerBranch?.map(br => {
            return {value: br.id, label: br.name, data: br}
        }))
    }

		return (
        <React.Fragment>
            <div className="page-content">
                <div className="container-fluid">
                    <Breadcrumbs title="Home" breadcrumbItem="Collectors" />
                    <Row>
                        <Col xl={12}>
                            <Card>
                                <CardBody>
                                    <Row>
                                        {message?<Alert color="success">{message}</Alert>:null}
                                        <div className="form-group col-md-4 mt-2">
                                            <Label className="form-label">
                                            <Trans>Driver</Trans>
                                            </Label>
                                            <Select
                                            name="driverId"
                                            value={
                                                driverId
                                                ? drivers.find(el => el.value === driverId)
                                                : null
                                            }
                                            options={drivers}
                                            className="form-control select2"
                                            onChange={e => setDriverId(e.value)}
                                            />
                                            &nbsp;
                                            <Label className="form-label">
                                                <Trans>Wallet Balance</Trans> <Trans size={5} style={{fontWeight:'bold'}}> 
                                                    {(drivers.find(el => el.value == driverId)?.data.user.wallet?.find(w => w.partnerBranchId == partnerBranchId)?.balance?.toString())}</Trans>
                                            </Label>
                                        </div>
                                        <div className="form-group col-md-4 mt-2">
                                            <Label className="form-label">
                                            <Trans>Partner</Trans>
                                            </Label>
                                            <Select
                                            name="partnerId"
                                            value={
                                                partners.find(el => el.value === partnerId)
                                            }
                                            options={partners}
                                            className="form-control select2"
                                            onChange={e => handlePartnerId(e.value)}
                                            />
                                        </div>
                                        <div className="form-group col-md-4 mt-2">
                                            <Label className="form-label">
                                            <Trans>Partner Branch</Trans>
                                            </Label>
                                            <Select
                                            name="partnerBranchId"
                                            value={
                                                partnerBranches?.find(el => el.value === partnerBranchId)
                                            }
                                            options={partnerBranches}
                                            className="form-control select2"
                                            onChange={e => setPartnerBranchId(e.value)}
                                            />
                                        </div>
                                        {per && (
                                        <div>
                                            <div className="form-group col-md-4 mt-2">
                                                <Label className="form-label">
                                                    <Trans>Wallet Balance</Trans>
                                                </Label>
                                                <Input
                                                    name="walletBalance"
                                                    value={drivers.find(el => el.value == driverId?.toString())?.data.user.wallet?.find(w => w.partnerBranchId == partnerBranchId)?.balance}
                                                    className="form-control"
                                                    placeholder=""
                                                    type="number"
                                                    onChange={e => setWalletBalance(e.target.value)}
                                                ></Input>
                                            </div>
                                            
                                            <Row>
                                                <div className="form-group col-md-12 mt-2 text-center">
                                                    <Button
                                                        type="button"
                                                        color="success"
                                                        onClick={handleTransferWallet}
                                                    >
                                                        <Trans>Do Transfer</Trans>
                                                    </Button>
                                                </div>

                                            </Row>
                                        </div>
                                        )}
                                    </Row>
                                    <Row>
                                        <div className="table-responsive">
                                            <Table className="table table-striped table-bordered mb-0">
                                                <thead>
                                                    <tr>
                                                        <th><Trans>Wallet ID</Trans></th>
                                                        <th><Trans>Partner Name</Trans></th>
                                                        <th><Trans>Partner Branch Name</Trans></th>
                                                        <th><Trans>Balance</Trans></th>
                                                        <th>
                                                            <Trans>Transction Date From</Trans> 
                                                                <Input
                                                                    name="trDateFrom"
                                                                    value={trDateFrom}
                                                                    className="form-control"
                                                                    placeholder=""
                                                                    type="date"
                                                                    onChange={e => setTrDateFrom(e.target.value)}
                                                                ></Input>
                                                            <Trans>Transction Date To</Trans>
                                                                <Input
                                                                    name="trDateTo"
                                                                    value={trDateTo}
                                                                    className="form-control"
                                                                    placeholder=""
                                                                    type="date"
                                                                    onChange={e => setTrDateTo(e.target.value)}
                                                                ></Input>
                                                            <div className="form-group col-md-3 mt-2 ">
                                                            <button
                                                                name="search"
                                                                className="form-control bg-primary text-white"
                                                                placeholder=""
                                                                type="button"
                                                                value="Search"
                                                                onClick={() => {setSearch(!search)}}
                                                            >
                                                                <Trans>Search</Trans>
                                                            </button>
                                                            </div>
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {loading ? <tr><th colSpan={10} className="text-center"><Loader></Loader></th></tr> : null}
                                                    {
                                                        driver?.user?.wallet.map((wallet, index) => {sum=0; return (
                                                            <tr key={index}>
                                                                <td>{wallet.id}</td>
                                                                <td>{wallet.partner?.name}</td>
                                                                <td>{wallet.partnerBranch?.name}</td>
                                                                <td>{wallet.balance}</td>
                                                                <td>
                                                                    <Table className="table table-striped table-bordered mb-0">
                                                                        <thead>
                                                                            <tr>
                                                                                <th><Trans>Order Id</Trans></th>
                                                                                <th><Trans>Name</Trans></th>
                                                                                <th><Trans>Amount</Trans></th>
                                                                                <th><Trans>Created At</Trans></th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                    {
                                                                        wallet.walletTransactions.map((tr, idx) => {sum +=tr.amount; return (
                                                                            <tr key={idx}>
                                                                                <td>{tr.relatedOrders?.join('-')}</td>
                                                                                <td>{tr.name}</td>
                                                                                <td>{tr.amount}</td>
                                                                                <td>{tr.createdAt.replace('T',' ').split('.')[0]}</td>

                                                                            </tr>
                                                                        )})
                                                                      
                                                                    }
                                                                            <tr key="idx">
                                                                                <td><b>Total</b></td>
                                                                                <td>{sum}</td>
                                                                                <td></td>

                                                                            </tr>
                                                                        </tbody>
                                                                    </Table>                                                                    

                                                                </td>
                                                            </tr>
                                                        )})
                                                    }
                                                </tbody>
                                            </Table>
                                        </div>

                                    </Row>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </div>
            </div>
        </React.Fragment >
	);
};

export default TransferWallet;
